"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawsService = void 0;
const games_1 = require("../models/games");
const Promotion_1 = require("../models/promotion/Promotion");
const TimeUtil_1 = require("../utils/TimeUtil");
const api_1 = require("./api");
const PATH = 'game/api';
const PATH_V2 = 'game/api/v2';
const DRAW_PATH = 'game/player/api';
class DrawsService {
    static async fetchPromotions({ page, size, sort }) {
        const requestParams = [`page=${page || 0}`, `size=${size || 10}`];
        if (sort) {
            requestParams.push(`sort=${sort}`);
        }
        else {
            requestParams.push(`sort=order,desc`);
            requestParams.push(`sort=name,asc`);
        }
        const url = `${DRAW_PATH}/promotions?promotionType.equals=SECOND_CHANCE&${requestParams.join('&')}`;
        try {
            const response = await api_1.API.get({ url });
            const promotions = Promotion_1.Promotion.JsonToEntities(response.content);
            const last = Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
            const totalPages = Math.ceil((response.totalElements - 1) / response.size);
            return {
                content: promotions,
                page: {
                    first: response.first,
                    last,
                    totalElements: response.totalElements,
                    totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchPromotionDetails(id) {
        const url = `${DRAW_PATH}/promotions/${id}`;
        try {
            const response = await api_1.API.get({ url });
            return Promotion_1.Promotion.JsonToEntity(response);
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchDrawsByPromotion(id, page, size) {
        const requestParams = [`page=${page || 0}`, `size=${size || 100}`];
        const url = `${DRAW_PATH}/draws?promotionId.equals=${id}&${requestParams.join('&')}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchGamesByPromotion(id) {
        const url = `${DRAW_PATH}/promotions/${id}/games`;
        try {
            const response = await api_1.API.get({ url });
            return games_1.Game.JsonToGames(response);
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchDraws({ page, size, sort, type, query }) {
        let requestParams = [`page=${page || 0}`, `size=${size || 10}`];
        if (sort) {
            requestParams.push(`sort=${sort}`);
        }
        else {
            requestParams.push(`sort=start,desc`);
            requestParams.push(`sort=name,asc`);
        }
        if (type) {
            requestParams.push(`type.equals=${type}`);
        }
        if (query && query.length > 0) {
            requestParams = [...requestParams, ...query];
        }
        else {
            requestParams.push('excludeFeatured=true');
        }
        const url = `${PATH}/draws/second-chance?${requestParams.join('&')}`;
        try {
            const response = await api_1.API.get({ url });
            let last = Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
            let totalPages = Math.ceil((response.totalElements - 1) / response.size);
            if (query && query.length > 0) {
                last = response.last;
                totalPages = response.totalPages;
            }
            return {
                content: response.content,
                page: {
                    first: response.first,
                    last,
                    totalElements: response.totalElements,
                    totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchDrawWithAdditionalInformation(id) {
        const url = `${PATH}/draws/${id}/additional-information`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchDrawPrizes(id) {
        const url = `${PATH}/draws/${id}/prizes`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchDrawPrizesWithContent(id) {
        const url = `${PATH}/draws/${id}/prizes-with-content`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchDrawPrizesWithWinners(id) {
        const url = `${PATH}/draws/${id}/prizes-with-winners`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchLatestDrawHistory(id) {
        const url = `${PATH}/draws/${id}/latest-live-draw-history`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchDrawEntryDetails(id) {
        const url = `${PATH}/draws/${id}/detail`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchSweepStakeDraws({ page, size, sort }) {
        const requestParams = [`page=${page || 0}`, `size=${size || 9999}`];
        if (sort) {
            requestParams.push(`sort=${sort}`);
        }
        else {
            requestParams.push(`sort=end,desc`);
            requestParams.push(`sort=name,asc`);
        }
        const url = `${PATH}/draws/sweepstakes?end.lessOrEqualThan=${(0, TimeUtil_1.nowUtc)().toISOString()}&${requestParams.join('&')}`;
        try {
            const response = await api_1.API.get({ url });
            const last = Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
            const totalPages = Math.ceil((response.totalElements - 1) / response.size);
            return {
                content: response.content,
                page: {
                    first: response.first,
                    last,
                    totalElements: response.totalElements,
                    totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async submitOptOutPrize(optOut) {
        try {
            return await api_1.API.put({
                url: `${PATH_V2}/draws/prize/opt-out`,
                body: optOut
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async submitOptOutPrizes(optOutList) {
        try {
            return await api_1.API.put({
                url: `${PATH_V2}/draws/prizes/opt-out`,
                body: optOutList
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async submitOptOutDraw(optOut) {
        try {
            return await api_1.API.put({
                url: `${PATH_V2}/draws/opt-out`,
                body: optOut
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchOptOutPreferences(drawIds) {
        try {
            return await api_1.API.post({
                url: `${PATH_V2}/draws/opt-out/preferences`,
                body: drawIds
            });
        }
        catch (error) {
            throw error;
        }
    }
}
exports.DrawsService = DrawsService;
//# sourceMappingURL=draws-service.js.map